<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_order_settings"
          @click="move"
        >保存しないで移動
        </button>
        <button class="btn" type="submit" name="note_order_settings"
          @click="saveAndMove"
        >保存して移動
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">ノートの編集の保存</span>
        </div>
        <div class="popup-content">
          <p class="txt">ページを移動する前にノートを保存してもよろしいですか？</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'SPNotePartPreventForgettingToSave',
  setup (props, context) {

    const close = () => {
      context.emit('close')
    }

    const move = () => {
      context.emit('move')
    }

    const saveAndMove = () => {
      // 保存時
      context.emit('saveAndMove')
    }

    return {
      close,
      move,
      saveAndMove
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    padding: 20px;
  }
  &-action {
    .button-submit {
      .btn + .btn {
        margin-top: 14px;
      }
    }
  }
}
</style>
